<template>
  <div class="is-relative has-text-centered">
    <div class="has-text-weight-semibold is-size-6 m-b-20">
      <span>
        {{ $t('platformreferral.free-will-referral-model.copy-share-link-via-sms-mail') }}
      </span>
    </div>
    <ButtonView class="left has-background-primary-light px-5 is-disabled" size="is-small">
      <i class="icon cls cls-hyperlink has-text-grey"></i>
    </ButtonView>
    <TooltipView type="is-dark" :label="$t('Copied to clipboard')" :active="isCopied">
      <ButtonView
        class="right"
        type="is-primary"
        size="is-small"
        :disabled="isLoading"
        @click="copyToClipboard"
        :data-e2e="ReferralCypressAttribute.buttons.COPY_REFERRAL_LINK"
      >
        {{ $t('platformreferral.free-will-referral-model.copy-referral-link') }}
      </ButtonView>
    </TooltipView>
  </div>
</template>

<script>
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';
import TooltipView from '@/modules/core/ui/components/wrappers/TooltipView.vue';
import { ReferralCypressAttribute } from '@/modules/referral/constants/ReferralCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'CopyReferralLink',
  components: { TooltipView, ButtonView },
  props: {
    referralLink: {
      type: String
    }
  },
  static: {
    ReferralCypressAttribute
  },
  data() {
    return {
      isCopied: false,
      platformReferral: null
    };
  },
  computed: {
    isLoading() {
      return !this.referralLink;
    }
  },
  methods: {
    copyToClipboard() {
      // Don't use IE
      navigator?.clipboard.writeText(this.referralLink);
      this.isCopied = true;
    }
  }
};
</script>

<style scoped>
.left.button.is-small:not(.is-rounded) {
  border-start-start-radius: var(--ce-8px) !important;
  border-end-start-radius: var(--ce-8px) !important;
}

.right.button.is-small:not(.is-rounded) {
  border-start-end-radius: var(--ce-8px) !important;
  border-end-end-radius: var(--ce-8px) !important;
}
</style>
